/* Visitor ID. Asks the dashboard whether this visit may load the identity vendor's script, and loads it only on a yes.
   The switches (on or off, stores, states left out) are in the dashboard's Visitor ID tab, so no theme holds a vendor key.
   Nothing here reads or sends an email address or a name. On a visit the gate said yes to, it reports the storefront's own visitor ID
   with the ad click ID the visit landed on and any hash the vendor's script holds, so the dashboard can tell which browser the person
   the vendor delivers was in. shopify/visitor-id/README.md */
(function () {
  try {
    if (window.EHQVisitorId) return;
    var GATE = 'https://admin.ecomhq.net/vid/gate', SAVED = 'ehq_vid', KEEP_MS = 30 * 60 * 1000;
    var tag = document.currentScript, shop = (tag && tag.getAttribute('data-shop')) || (window.Shopify && window.Shopify.shop) || '';
    var state = window.EHQVisitorId = { shop: shop, answer: null, loaded: [] };
    // The theme editor and a shopper who turned marketing off never load it.
    if (!shop || (window.Shopify && window.Shopify.designMode)) return;
    // A browser that sends Global Privacy Control has opted out, as every store's privacy policy says: it asks nothing and loads nothing,
    // on the owner's test link too.
    var gpc = navigator.globalPrivacyControl;
    if (gpc === true || gpc === 1 || gpc === '1') { state.answer = { on: false, why: 'gpc' }; return; }
    try { if (window.Shopify.customerPrivacy.marketingAllowed() === false) return; } catch (e) {}

    // One entry for each vendor: what its own install snippet does, given the account key.
    var vendors = {
      // Retention.com's Shopify theme snippet, version 1.6.1, as its install guide gives it.
      retention: function (key) {
        var geq = window.geq = window.geq || [];
        if (geq.initialize || geq.invoked) return;
        geq.invoked = true;
        geq.methods = ['page', 'suppress', 'track', 'doNotTrack', 'trackOrder', 'identify', 'addToCart', 'callBack', 'event'];
        geq.factory = function (method) { return function () { var args = Array.prototype.slice.call(arguments); args.unshift(method); geq.push(args); return geq; }; };
        for (var i = 0; i < geq.methods.length; i++) geq[geq.methods[i]] = geq.factory(geq.methods[i]);
        geq.load = function (k) {
          var s = document.createElement('script'); s.type = 'text/javascript'; s.async = true;
          s.src = 'https://s3-us-west-2.amazonaws.com/jsstore/a/' + k + '/ge.js' + (location.href.indexOf('vge=true') >= 0 ? '?v=' + Math.random() : '');
          var first = document.getElementsByTagName('script')[0]; first.parentNode.insertBefore(s, first);
        };
        geq.SNIPPET_VERSION = '1.6.1';
        geq.load(key);
      },
      // Customers.ai's website pixel, as its account gives it: one async script named by the account's key. The backup vendor.
      leadpost: function (key) {
        // LeadPost account Pixel Assistant, verified October 16, 2026; aid is audience-specific.
        if (!/^[0-9]{1,12}$/.test(key) || window.EHQVisitorIdLeadPost) return;
        window.EHQVisitorIdLeadPost = true; window.rdcndbg = false;
        var s = document.createElement('script'); s.async = true; s.src = 'https://rdcdn.com/rtjs?aid=' + key;
        var first = document.getElementsByTagName('script')[0]; first.parentNode.insertBefore(s, first);
      },
      customersai: function (key) {
        if (window.EHQVisitorIdCai) return; window.EHQVisitorIdCai = true;
        var s = document.createElement('script'); s.async = true; s.src = 'https://mm-uxrv.com/js/mm_' + key + '.js';
        var first = document.getElementsByTagName('script')[0]; first.parentNode.insertBefore(s, first);
      }
    };
    // Which browser is which person. Two things tie this browser to the person the vendor then delivers, so that what the visitor does here
    // (time on a page, a product looked at, a cart) can become theirs: the ad platform's own click ID in the address this visit landed on,
    // which the vendor's delivery names too, and a hash of the address the vendor's script found, in the cookies where it keeps them.
    // Reported beside the storefront's own visitor ID (the hq_vid cookie), only on a visit the gate said yes to, and again only when
    // there is something new to say.
    var CLICKS = ['fbclid', 'gclid', 'gbraid', 'wbraid', 'ttclid', 'msclkid', 'twclid', 'epik', 'sccid', 'li_fat_id'];
    var click = '';
    try {
      for (var c = 0; c < CLICKS.length && !click; c++) { var hit = location.search.match(new RegExp('[?&]' + CLICKS[c] + '=([A-Za-z0-9._~-]{16,200})(?:&|$)')); if (hit) click = hit[1]; }
      // A later page of the visit has no click ID in its address: the one the visit landed with is kept for the tab's session.
      if (click) sessionStorage.setItem(SAVED + '_click', click); else click = sessionStorage.getItem(SAVED + '_click') || '';
    } catch (e) {}
    // A hash as the vendor keeps it: hex, or the same wrapped in base64.
    var hexOf = function (value, length) {
      var v = String(value || ''), shape = new RegExp('^[a-f0-9]{' + length + '}$');
      try { v = decodeURIComponent(v); } catch (e) {}
      if (shape.test(v.toLowerCase())) return v.toLowerCase();
      try { var plain = atob(v).toLowerCase(); if (shape.test(plain)) return plain; } catch (e) {}
      return '';
    };
    var kept = function (name) {
      var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]+)')); if (m) return m[1];
      try { return localStorage.getItem(name) || ''; } catch (e) { return ''; }
    };
    var hashFrom = function (g, names, props, length) {
      for (var i = 0; i < names.length; i++) { var a = hexOf(kept(names[i]), length); if (a) return a; }
      for (var j = 0; g && j < props.length; j++) { var b = hexOf(g[props[j]], length); if (b) return b; }
      return '';
    };
    var link = function () {
      try {
        var g = window.geq; if (g instanceof Array) g = null;
        var vid = (document.cookie.match(/(?:^|; )hq_vid=([^;]+)/) || [])[1] || '';
        if (!vid) { try { vid = localStorage.getItem('hq_vid') || ''; } catch (e) {} }
        vid = decodeURIComponent(vid);
        // Retention.com's script keeps what its partners told it in these cookies (md5 first, then the longer hash).
        var md5 = hashFrom(g, ['_gecb_m', '_geli', '_geff', '_getd'], ['re_md5', 're_li', 're_ff', 're_td'], 32);
        var sha2 = hashFrom(g, ['_gecb_s', '_gelisha'], ['re_sha2'], 64);
        var mark = md5 + '|' + sha2 + '|' + click;
        if (!vid || mark === '||' || sessionStorage.getItem(SAVED + '_link') === mark) return;
        var x = new XMLHttpRequest();
        x.open('POST', GATE.replace('/gate', '/link'));
        x.setRequestHeader('Content-Type', 'text/plain');
        x.onload = function () { if (x.status === 204) { try { sessionStorage.setItem(SAVED + '_link', mark); } catch (e) {} } };
        x.send(JSON.stringify({ shop: shop, vid: vid, md5: md5, sha2: sha2, click: click, uid: String((g && g.uuid) || '').slice(0, 80), pi: String((g && g.userID) || '').slice(0, 80) }));
      } catch (e) {}
    };
    var run = function (answer) {
      state.answer = answer;
      if (!answer || answer.on !== true || !answer.scripts) return;
      for (var i = 0; i < answer.scripts.length; i++) {
        var s = answer.scripts[i];
        if (s && vendors[s.vendor] && /^[A-Za-z0-9_-]{1,80}$/.test(s.key || '')) { try { vendors[s.vendor](s.key); state.loaded.push(s.vendor); } catch (e) {} }
      }
      // At once for the click this visit landed with, then again as the vendor's script learns more.
      if (state.loaded.length) for (var t = 0, waits = [0.5, 4, 12, 30, 60, 100, 180]; t < waits.length; t++) setTimeout(link, waits[t] * 1000);
    };

    // The owner's test link (?ehq_vid_test=<code> from the dashboard) asks the gate afresh and is remembered for the session.
    var test = '', testVendor = '';
    try { test = (location.search.match(/[?&]ehq_vid_test=([A-Za-z0-9]{1,64})/) || [])[1] || sessionStorage.getItem(SAVED + '_test') || ''; if (test) sessionStorage.setItem(SAVED + '_test', test); } catch (e) {}
    // On the test link, `ehq_vid_vendor=<name>` asks for that vendor's script, so a second vendor can be checked before it is switched on.
    try { testVendor = test ? ((location.search.match(/[?&]ehq_vid_vendor=([a-z]{1,20})/) || [])[1] || sessionStorage.getItem(SAVED + '_vendor') || '') : ''; if (testVendor) sessionStorage.setItem(SAVED + '_vendor', testVendor); } catch (e) {}
    // The storefront's own visitor ID, when this browser has one: the dashboard offers a browser the other vendor on a later visit when the
    // first found nobody, so it has to know which browser this is. Nothing about the person is in it.
    var vidNow = '';
    try { vidNow = decodeURIComponent((document.cookie.match(/(?:^|; )hq_vid=([^;]+)/) || [])[1] || localStorage.getItem('hq_vid') || ''); } catch (e) {}
    // The answer is kept for this browser tab's session, so a visit asks once, not on every page.
    var saved = null;
    try { saved = JSON.parse(sessionStorage.getItem(SAVED) || 'null'); } catch (e) {}
    if (saved && saved.shop === shop && saved.test === test && saved.vendor === testVendor && saved.until > Date.now()) { run(saved.answer); return; }
    var xhr = new XMLHttpRequest();
    xhr.open('GET', GATE + '?lp=1&shop=' + encodeURIComponent(shop) + (test ? '&test=' + test + (testVendor ? '&vendor=' + testVendor : '') : '') + (/^[a-z0-9]{1,12}-[A-Za-z0-9]{8,32}$/.test(vidNow) ? '&vid=' + vidNow : ''));
    xhr.timeout = 6000;
    xhr.onload = function () {
      if (xhr.status !== 200) return;
      var answer; try { answer = JSON.parse(xhr.responseText); } catch (e) { return; }
      try { sessionStorage.setItem(SAVED, JSON.stringify({ shop: shop, test: test, vendor: testVendor, until: Date.now() + KEEP_MS, answer: answer })); } catch (e) {}
      run(answer);
    };
    xhr.send();
  } catch (e) {}
})();
